export class SearchParams {
    public citationNumber: string | null = '';
    public vehicleState: string | null = '';
    public vehicleLicense: string | null = '';
}
